export default __webpack_public_path__ + "dc7e160aa7ce45f7fef2f9eefadee7e0.png";